class o{constructor(){this.enabled=!0,this.rootBone=null}}export{o as RenderComponentData};
